<template>
  <section class="">
      <ListaJuegos/>
  </section>
</template>

<script>
import ListaJuegos from '@/components/ListaJuegos.vue'

export default {
    name: "VistaPrincipal",
    components:{
      ListaJuegos
    }
}
</script>

<style>

</style>